"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.Refresh = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    d: "M8.00427 12.3C5.62945 12.3 3.70427 10.3748 3.70427 8C3.70427 5.62518 5.62945 3.7 8.00427 3.7C9.1317 3.7 10.1578 4.13389 10.9246 4.8438L8.9606 6.0235L14.0043 8.01014V2.99404L12.4246 3.94282C11.3279 2.74856 9.75352 2 8.00427 2C4.69056 2 2.00427 4.68629 2.00427 8C2.00427 11.3137 4.69056 14 8.00427 14C10.226 14 12.1657 12.7925 13.2028 10.9979L11.7306 10.1473C10.9875 11.434 9.59701 12.3 8.00427 12.3Z"
  })));
};